const operationTypesMapper = (operationType: string): string => {
  const operationsTranslation: Record<string, string> = {
    Acquire: 'Top-up & Data',
    P2PTransfer: 'P2P transfer',
    OnDemandDebit: 'On Demand Debit',
    Transfer: 'Account Transfer',
    Payout: 'Payout',
    BankLedPayment: 'Bank Led Payment',
    MerchantPayment: 'Merchant Payment',
    OnDemandPaymentAndAcquisition: 'On Demand Payment And Acquisition',
    AdminCredit: 'Admin Credit',
    TransferCredit: 'Transfer Credit',
    MerchantPaymentCredit: 'Merchant Payment Credit',
    AirtimeBalanceModification: 'Top-up & data Balance Modification',
    Sms: 'SMS',
    OperatorQuery: 'Operator Lookup',
    CustomerValidation: 'Customer Validation',
    UssdSession: 'USSD session',
    WapSession: 'WAP session',
    SipSession: 'Voice session',
    AddAccount: 'Add Account',
    CustomerAuthentication: 'Customer Authentication',
    CustomerEnrollment: 'Customer Enrollment'
  };

  return operationsTranslation[operationType] ?? operationType;
};

export default operationTypesMapper;
